import { render, staticRenderFns } from "./ShowCommentImage.vue?vue&type=template&id=7a2859fc"
import script from "./ShowCommentImage.vue?vue&type=script&lang=js"
export * from "./ShowCommentImage.vue?vue&type=script&lang=js"
import style0 from "./ShowCommentImage.vue?vue&type=style&index=0&id=7a2859fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports